import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ActivityShareView from "@/components/ActivityShareView.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SharePage',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createBlock(_component_a_flex, {
    vertical: "",
    justify: "center",
    align: "center",
    class: "bg"
  }, {
    default: _withCtx(() => [
      _createVNode(ActivityShareView, {
        title: "",
        "activity-id": _ctx.$route.query.activity_id,
        "is-edit": true
      }, null, 8, ["activity-id"])
    ]),
    _: 1
  }))
}
}

})